<svg [attr.height]="size" [attr.width]="size" fill="none" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg">
  <path [attr.stroke]="color" d="M10.07 5.93018L4 12.0002L10.07 18.0702" stroke-linecap="round" stroke-linejoin="round"
        stroke-miterlimit="10" stroke-width="1.5"/>
  <path [attr.stroke]="color" d="M20.9999 12H4.16992" stroke-linecap="round" stroke-linejoin="round"
        stroke-miterlimit="10"
        stroke-width="1.5"/>
</svg>
